import { render } from "./LicenseTrialFailureDialog.vue?vue&type=template&id=b0239994&scoped=true"
import script from "./LicenseTrialFailureDialog.vue?vue&type=script&lang=js"
export * from "./LicenseTrialFailureDialog.vue?vue&type=script&lang=js"

import "./LicenseTrialFailureDialog.vue?vue&type=style&index=0&id=b0239994&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0239994"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSpinnerDots,QBtn});
